export default "__VITE_ASSET__Uf3ExURB__"